export default __webpack_public_path__ + "static/media/DSC_9136.3872be1b.jpg";